import { Component, OnInit, OnDestroy } from "@angular/core";
import { ExpiringCode } from "@edp-models/edp-expiring-code.model";
import { IAppState } from "@edp-store/state/app.state";
import { Store, select } from "@ngrx/store";
import { takeUntil, filter } from "rxjs/operators";
import { Subject } from "rxjs";
import { getPartnerInfo } from "@edp-store/selectors/contract.selectors";

@Component({
    selector: "edp-widget-advantages-and-benefits",
    templateUrl: "./edp-widget-advantages-and-benefits.component.html",
    styleUrls: ["./edp-widget-advantages-and-benefits.component.scss"]
})
export class EdpWidgetAdvantagesAndBenefitsComponent implements OnInit, OnDestroy {
    public expiringCode: ExpiringCode = null;
    private unsubscribe = new Subject();

    constructor(
        private store: Store<IAppState>
    ) {}

    public ngOnInit() {
        this.store.pipe(
            takeUntil(this.unsubscribe),
            select(getPartnerInfo),
            filter(val => val !== null && val !== undefined)
        ).subscribe((partnerInfo) => {
            if (partnerInfo.expiringCodes && partnerInfo.expiringCodes.length > 0) {
                this.expiringCode = {
                    ...partnerInfo.expiringCodes[0],
                    validity_date: partnerInfo.expiringCodes[0].validity_date.replace(/-/g, "/")
                };
            }
        });
    }

    public ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
